var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import UnopenInvestmentDialog from './UnopenInvestmentDialog.vue';
import { Component, Vue } from 'vue-property-decorator';
import { userLogout } from '@views/login/api/auth';
// import { getLocationStatus } from '@views/investment/api/investment';
import { getBigDataExtra } from '@/common/utils/burying-point';
import { getEnv } from '@/common/utils/env';
import store from '@/store/index';
import InviteCollaboratorPopover from './InviteCollaboratorPopover.vue';
import DownloadAppPopover from './DownloadAppPopover.vue';
import UserInfoPopover from './UserInfoPopover.vue';
import CrmMemu from './CrmMenu.vue';
import VersionHint from '@/layout/components/Header/VersionHint.vue';
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.showControl = false;
        _this.showEnterprise = false;
        _this.showDialog = false;
        _this.adminName = '';
        _this.adminMobile = '';
        _this.enterpriseList = [];
        _this.showTabArr = ['/store', '/store/add'];
        return _this;
    }
    Object.defineProperty(Header.prototype, "crmUserInfo", {
        /* computed */
        get: function () {
            return store.state.user.userInfo || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "stateCommon", {
        get: function () {
            return store.state.common || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "permissions", {
        get: function () {
            return this.stateCommon.permission || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "user", {
        get: function () {
            return this.stateCommon.user || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "firstName", {
        get: function () {
            var _a = this.user, name = _a.name, companyName = _a.companyName;
            if (name) {
                return name.substring(0, 1);
            }
            else if (companyName) {
                return companyName.substring(0, 1);
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "ENV", {
        get: function () {
            var isProd = process.env.NODE_ENV === 'production';
            var env = isProd ? getEnv() : process.env.npm_config_env;
            return env;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "showTab", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "bigDataExtra", {
        get: function () {
            return JSON.stringify(getBigDataExtra());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "routeMeta", {
        get: function () {
            return this.$route.meta;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Header.prototype, "otherCrumb", {
        get: function () {
            if (!this.routeMeta.otherCrumbs)
                return false;
            var _a = this.routeMeta.otherCrumbs.judge, key = _a.key, value = _a.value;
            return this.$route.query[key] === value;
        },
        enumerable: false,
        configurable: true
    });
    /* hooks */
    Header.prototype.mounted = function () {
        this.$store.commit('REQUIRE_AUTH', true);
    };
    /* methods */
    // 跳转设置
    Header.prototype.jumpSet = function () {
        this.$store.commit('SET_TAB', 'set');
        this.$router.push({ path: "/setting/role" });
        var mapUrl = {
            'shopList': '/setting/store',
            'approvalFlow_list': '/setting/approvalFlow',
            'boothCategoryList': '/setting/boothClassify',
            'holidayList': '/setting/holidays',
            'targetList': '/setting/revenue',
        };
        var hasTargetUrl = false;
        for (var url in mapUrl) {
            if (this.permissions[url]) {
                hasTargetUrl = true;
                this.$router.push({ path: "" + mapUrl[url] });
                return false;
            }
        }
        if (!hasTargetUrl) { // 都没权限时
            this.$router.push({ path: "/permission" });
        }
    };
    // 退出登录
    Header.prototype.logout = function () {
        userLogout().then(function () {
            window.$_EventLib.dispatch('LOGOUT', null);
        });
    };
    Header.prototype.toUpdate = function () {
        window.open('/update');
    };
    Header.prototype.toBusiness = function () {
        window.open('/lhb-micro-pms/business');
    };
    // 招商模块
    Header.prototype.toInvestment = function () {
        this.$router.push({
            path: '/investment',
        });
        // getLocationStatus().then(({ data }: any) => {
        //   const user = this.$store.state.common.user;
        //   user.is_location = data.is_location;
        //   this.$store.commit('UPDATE_USER', user);
        //   if (data.is_location === 1) {
        //     return this.$router.push({
        //       path: '/investment/list'
        //     });
        //   }
        //   if (this.user.roleName === 'admin') {
        //     this.$router.push({
        //       path: '/investment'
        //     });
        //   } else {
        //     this.showDialog = true;
        //     this.adminName = data.name;
        //     this.adminMobile = data.mobile;
        //   }
        // }).catch((err: any) => {
        //   console.error(err.message);
        // });
    };
    Header.prototype.openInviteCollaboratorPopover = function () {
        this.$refs.inviteCollaboratorPopover && this.$refs.inviteCollaboratorPopover.init();
    };
    Header = __decorate([
        Component({
            components: {
                UnopenInvestmentDialog: UnopenInvestmentDialog,
                InviteCollaboratorPopover: InviteCollaboratorPopover,
                DownloadAppPopover: DownloadAppPopover,
                UserInfoPopover: UserInfoPopover,
                CrmMemu: CrmMemu,
                VersionHint: VersionHint,
            },
        })
    ], Header);
    return Header;
}(Vue));
export default Header;
